<template>
    <div class="learners">
        <p class="card-body pt-0 text-sm" v-if="empty">{{ $t('dashboard.no-learner') }}</p>

        <div v-if="!empty">
            
            <table-control :paging="paging" :search="true" v-model="search"></table-control>

            <el-table class="table-responsive table-flush"
                    :show-header="false"
                    :data="filteredLearners">

                <el-table-column width="72">
                    <template v-slot="{row}">
                        <a href="#" class="avatar rounded-circle" :class="{'disabled': isWithdrawed(row)}"
                                @click.prevent="openLearner(row)">
                            <img :src="row.avatar">
                        </a>
                    </template>
                </el-table-column>

                <el-table-column>
                    <template v-slot="{row}">
                        <div :class="{'disabled': isWithdrawed(row)}">
                            <h4 class="mb-0">
                                <a href="#" @click.prevent="openLearner(row)">
                                    {{row.name}}
                                </a>
                            </h4>
                            <small v-if="row.owner">
                                {{ row.owner.name }}
                            </small>
                            <small v-if="row.entity">
                                / {{ row.entity.name }}
                            </small>
                        </div>
                    </template>
                </el-table-column>

                <el-table-column align="right" class-name="actions">
                    <template v-slot="{row}">
                        <div class="p-1">

                            <base-button type="primary" size="sm" @click="openLearner(row)">
                                {{ $t('dashboard.follow-up') }}
                            </base-button>
                        </div>
                        
                    </template>
                </el-table-column>
            </el-table>

            <table-pagination :paging="paging"></table-pagination>                
        </div>
    </div>
</template>

<script>
    export default {

        props: {

            cohort: {
                type: Object,
                required: true
            },

            learners: {
                type: Array,
            }
        },

        data() {
            return {
                paging: {
                    currentPage: 1,
                    perPage: 10,
                    total: 0
                },
                search: '',
            }
        },

        computed: {

            empty() {
                return this.learners.length == 0 && !this.search
            },

            filteredLearners() {
                // Search filter.
                let learners = this.learners.filter(learner => !this.search
                    || learner.name.toLowerCase().includes(this.search.toLowerCase())
                )
                // Sorting.
                learners = learners.sort((a, b) => a.name.toUpperCase() > b.name.toUpperCase() ? 1 : -1)
                this.paging.total = learners.length
                return learners.slice((this.paging.currentPage - 1) * this.paging.perPage, this.paging.currentPage * this.paging.perPage)
            },
        },

        methods: {     

            isWithdrawed(learner) {
                return !learner.pivot.active
            },

            openLearner(learner) {
                this.$router.push({ name: 'dashboard-learner', params: { learnerId: learner.id } })
            }
        }
    }
</script>

<style scoped>

    .learners >>> th,
    .learners >>> td {
        padding-right: 0;
    }
    .learners >>> th.actions,
    .learners >>> td.actions {
        padding-right: 1.5rem;
    }
    .learners >>> .table-control form {
        width: 100%;
    }
    .disabled, .disabled h4 {
        color: #bbb !important;
    }
    .disabled img {
        opacity: 0.5;
    }
    
</style>
